import React, { useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { currentLanguage } from "../../i18n";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/HeroSection/HeroSection";
import ServicesSection from "../../components/ServicesSection/ServicesSection";
import TabSection from "../../components/TabSection/TabSection";
import ShowcaseSection from "../../components/ShowcaseSection/ShowcaseSection";
import PlatformVisualSection from "../../components/PlatformVisualSection/PlatformVisualSection";
import TestimonialsSection from "../../components/TestimonialsSection/TestimonialsSection";
import FaqSection from "../../components/FaqSection/FaqSection";
import ContactSection from "../../components/ContactSection/ContactSection";
import FooterSection from "../../components/FooterSection/FooterSection";
import CookieBanner from "../../components/CookieBanner/CookieBanner";

interface MainPageProps {
  scrollToContact?: boolean;
}

const MainPage: React.FC<MainPageProps> = ({ scrollToContact = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const solutionsRef = useRef<HTMLDivElement>(null);
  const insightsRef = useRef<HTMLDivElement>(null);
  const aboutRef = useRef<HTMLDivElement>(null);
  const blogRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const pressRef = useRef<HTMLDivElement>(null);
  const testimonialRef = useRef<HTMLDivElement>(null);
  const showcaseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      console.log("master image test passed");
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (location.search) {
      navigate(location.pathname, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentHash = location.hash;

    if (!currentPath.match(/^\/[a-z]{2}(\/|$)/)) {
      const newPath = `/${currentLanguage}${currentPath === "/" ? "" : currentPath}${currentHash}`;
      window.history.replaceState(null, "", newPath);
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (scrollToContact && contactRef.current) {
      setTimeout(() => {
        contactRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [scrollToContact]);

  return (
    <div>
      <Header
        sectionRefs={{
          solutions: solutionsRef,
          insights: insightsRef,
          about: aboutRef,
          blog: blogRef,
          contact: contactRef,
        }}
      />
      <CookieBanner />
      <HeroSection />
      <ServicesSection />
      <TabSection />
      <div ref={showcaseRef}>
        <ShowcaseSection />
      </div>
      <div ref={testimonialRef}>
        <TestimonialsSection />
      </div>

      <PlatformVisualSection />

      <FaqSection />
      <div ref={contactRef} data-contact-section>
        <ContactSection />
      </div>

      <FooterSection
        missionRef={missionRef}
        pressRef={pressRef}
        testimonialRef={testimonialRef}
        blogRef={blogRef}
        showcaseRef={showcaseRef}
        solutionsRef={solutionsRef}
        contactRef={contactRef}
      />
    </div>
  );
};

export default MainPage;
